export enum MediaValidation {
  EXCESSIVE_BITRATE = 'EXCESSIVE_BITRATE',
  VARIABLE_FRAME_RATE = 'VARIABLE_FRAME_RATE',
  UNEXPECTED_FILE_TYPE = 'UNEXPECTED_FILE_TYPE',
  UNEXPECTED_DURATION = 'UNEXPECTED_DURATION',
  WRONG_ASPECT_RATIO = 'WRONG_ASPECT_RATIO',
  NO_SOUND = 'NO_SOUND',
}
